const data = [
  {
    title: "Science Fuse",
    image: "/img/partners/fuse.jpg",
    link: "https://sciencefuse.com/",
  },
  {
    title: "Pakistan Alliance for Maths & Science",
    image: "/img/partners/pams.png",
    link: "https://mathsandscience.pk/",
  },
  {
    title: "Exploration by Yumna",
    image: "/img/partners/exploration.jpg",
    link: "https://www.facebook.com/explorationbyyumna",
  },
  {
    title: "Scientia",
    image: "/img/partners/scientia.jpg",
    link: "http://scientiamag.org/",
  },
];

export default data;
